<header class="header--container">
    
    <div class="header--wrapper">
        <a routerLink="/" class="header--logo">
            <img src="assets/images/logo/logo-oneam@2x.jpg" alt="header-logo" />
        </a>
        <div class="header--menu">
            <div class="addition--menu">
                <div class="quick--menu">
                    <ng-container *ngTemplateOutlet="searchInput"></ng-container>
                    <a routerLink="/Favorite" class="favorite--menu">
                        <span class="badge">
                          <span style="position: absolute; top: 22%;">{{favNum}}</span>
                        </span>
                        <i class="fas fa-heart"></i>
                    </a>
                    <a routerLink="/Calendar" class="favorite--menu">
                        <i class="fas fa-calendar"></i>
                    </a>
                    <div (click)="_onToggleMenu()" class="hamburger">
                        <i *ngIf="!isShowMenu" class="fas fa-bars"></i>
                        <i *ngIf="isShowMenu" class="fas fa-times"></i>
                    </div>
                </div>
                <app-button text={{language.oneLive}} (click)="gotoOneLive()"></app-button>

                <div *ngIf="language_flag=='en'">
                    <img (click)="changelanguage('th')" style="width: 25px; height: 25px; margin: 5px; cursor: pointer;" src="/assets/images/th_non.png" alt="">
                    <img (click)="changelanguage('en')" style="width: 25px; height: 25px; margin: 5px; cursor: pointer;" src="/assets/images/en.png" alt="">
                </div>

                <div *ngIf="language_flag=='th'">
                    <img (click)="changelanguage('th')" style="width: 25px; height: 25px; margin: 5px; cursor: pointer;" src="/assets/images/th.png" alt="">
                    <img (click)="changelanguage('en')" style="width: 25px; height: 25px; margin: 5px; cursor: pointer;" src="/assets/images/en_non.png" alt="">
                </div>


            </div>
            <ng-container *ngTemplateOutlet="mainMenu"></ng-container>
        </div>
    </div>

    <div class="header--hambergur-menu" [ngClass]="isShowMenu ? 'show' : 'hide'">
        <div class="quick--menu">
            <ng-container *ngTemplateOutlet="searchInput"></ng-container>
            <app-button text={{language.oneLive}} (click)="gotoOneLive()"></app-button>
        </div>
        <div class="menu-wrapper">
            <ng-container *ngTemplateOutlet="mainMenu"></ng-container>
            <ng-container *ngTemplateOutlet="subMenu"></ng-container>
        </div>

    </div>

</header>

<ng-template #mainMenu>
    <div class="main--menu">
        <a (click)="hideMenu()" *ngFor="let menu of menuList" [routerLink]="menu.path" routerLinkActive="active">{{menu.title}}</a>
    </div>
</ng-template>

<ng-template #subMenu>
    <div class="main--menu">
        <a (click)="hideMenu()" *ngFor="let subMenu of submenuList" [routerLink]="subMenu.path" routerLinkActive="active">{{subMenu.title}}</a>
    </div>
</ng-template>

<ng-template #searchInput>
    <div (click)="_onShowSearch()" class="search--menu {{isToggleSearch ? 'expanded': '' }}">
        <input (blur)="_onHideSearch()" #search *ngIf="isToggleSearch" type="text" [(ngModel)]="searchValue" placeholder={{language.search}} (keydown)="getSearch($event)" />
        <i class="fas fa-search" *ngIf="icon_show"></i>
    </div>
</ng-template>

